// The entity a login on this site asks studx-authen for. One build serves both
// universities and they are told apart by hostname, as Login.vue's logo choice
// already is. Any other host (localhost, an IP) sends nothing, and authen uses
// the user's primary entity.
export function loginEntityFromHostname(hostname) {
  const value = typeof hostname === 'string' ? hostname : '';
  if (value.includes('western')) return 'x-studi-western';
  if (value.includes('nation')) return 'x-studi-nation';
  return undefined;
}
